import React, { useState, useEffect } from 'react'
import { User_Authentication } from '../../../user_authentication/User_Authentication';
import { Default_Shipping_Address, Remove_Shipping_Address, Shipping_Address, Update_Shipping_Address } from '../../../api/category_product/Category_Product';
import { Link } from 'react-router-dom';
import Loader from '../../../loader/Loader';
import { toast } from "react-toastify";
import PhoneInput, {
    parsePhoneNumber,
    isValidPhoneNumber,
} from "react-phone-number-input";
import "react-phone-number-input/style.css";
import { isAlphabetical } from '../../validation/Validation';
import { countries } from '../../../utils/countries';



const Address_List = ({ onActiveShippingAddressChange }) => {
    const [address_list, set_Address_list] = useState([]);
    const [active_shiping_address, set_Active_Shiping_Address] = useState(null);
    const [is_loading, set_Is_Loading] = useState(false)
    const [isPopupOpen, setIsPopupOpen] = useState(false);
    const [errors, setErrors] = useState({});


    //    <------------ Edit the Shiping Address ----------->
    const [mobileNumber, setMobileNumber] = useState("");
    const [phoneNumber, setPhoneNumber] = useState("+91");
    const [countryCode, setCountryCode] = useState("IN");
    const [isValid, setIsValid] = useState(false);
    const [edit_select_address, set_Edit_Select_Address] = useState({
        name: '',
        house_name: '',
        address: '',
        city: '',
        state: '',
        country: '',
        pin_code: '',
        landmark: '',
        address_type: '',
    });

    console.log("edit_select_address", edit_select_address);

    // <------- Address list -------->

    const Handle_Get_Address_List = async () => {
        set_Is_Loading(true)
        try {
            const token = User_Authentication();
            if (!token) {
                set_Is_Loading(false);
                throw new Error("User token not found");
            }
            const response = await Shipping_Address({ Authorization: `Bearer ${token}` })
            if (response?.data?.status == "200") {
                set_Address_list(response?.data?.data?.shipping_addresses)

                set_Is_Loading(false)
            }
            else if (response?.response?.data?.status == "500") {
                set_Is_Loading(false)
            }
        } catch (error) {
            set_Is_Loading(false)
        }
    }
    useEffect(() => {
        Handle_Get_Address_List();
    }, [])

    // <<------------ remove-shipping-address ----------->
    const Handle_Remove_Shipping_Address = async (id) => {
        set_Is_Loading(true)
        const data = {
            id: id
        }
        try {
            const token = User_Authentication();
            if (!token) {
                set_Is_Loading(false);
                throw new Error("User token not found");
            }
            const response = await Remove_Shipping_Address(data, { Authorization: `Bearer ${token}` })
            if (response?.data?.status == "200") {
                set_Is_Loading(false)
                set_Address_list((prevList) => prevList?.filter((address) => address?.id != id))
            }
            else if (response?.response?.data?.status == "500") {
                set_Is_Loading(false)
            }
        }
        catch (error) {
            set_Is_Loading(false)
        }
    }

    // Open the popup and set the selected address for editing
    const Handle_Open_Edit_Popup = (address) => {
        const fullPhone = `${address?.country_code || "+91"}${address?.phone_number || ""}`;
        setMobileNumber(address?.phone_number)
        setPhoneNumber(fullPhone)
        setCountryCode(address?.country_code)
        set_Edit_Select_Address(address);
        setIsPopupOpen(true);
    };

    const newErrors = {};
    const handleInputChange = (e) => {
        setErrors({});
        const { name, value } = e.target;

        if (name === 'name' && value.length && !isAlphabetical(value)) {
            newErrors[name] = "Name should contain only alphabetical characters.";
            setErrors(newErrors);
            return;
        }
        if (name === 'pin_code' && value.length > 6) {
            newErrors[name] = "Pin code should be a valid 6-digit number.";
            setErrors(newErrors);
            return;
        }
        set_Edit_Select_Address(prev => ({
            ...prev,
            [name]: value,
        }));
    }


    // <----------- Onchnage Events on the Phone Input section's -------------->
    const handlePhoneChange = (value) => {

        if (!value || !value.startsWith("+")) {
            setPhoneNumber("+91");
            setCountryCode("91");
            setMobileNumber("");
            return;
        }


        setPhoneNumber(value);

        try {
            const parsedPhone = parsePhoneNumber(value);
            setCountryCode(parsedPhone.countryCallingCode);
            setMobileNumber(parsedPhone.nationalNumber);
        } catch (error) {
            setMobileNumber("");
        }
    };

    // <----------- Handle Key Down Events on the Phone Input section's -------------->
    const handleKeyDown = (e) => {
        // Prevent deleting the "+" or the country code
        if (
            (e.key === "Backspace" || e.key === "Delete") &&
            phoneNumber &&
            phoneNumber.length <= 3 // block when cursor is within "+91"
        ) {
            e.preventDefault();
        }
    };

    useEffect(() => {
        setIsValid(isValidPhoneNumber(phoneNumber));
    }, [phoneNumber]);

    // <---------- Handle Edit Address ----------->
    const Handle_Edit_Shipping_Address = async () => {
        set_Is_Loading(true)
        const data = {
            id: edit_select_address.id,
            name: edit_select_address.name,
            house_name: edit_select_address.house_name,
            address: edit_select_address.address,
            phone_number: mobileNumber,
            country_code: `+${countryCode}`,
            city: edit_select_address.city,
            state: edit_select_address.state,
            country: edit_select_address.country,
            pin_code: edit_select_address.pin_code,
            landmark: edit_select_address.landmark,
            address_type: edit_select_address.address_type,
        }
        if (!edit_select_address?.name) {
            toast("please enter your name")
            set_Is_Loading(false)
            return
        }
        if (!edit_select_address?.house_name) {
            toast("please enter your House/Flat/Block Name:")
            set_Is_Loading(false)
            return
        }
        if (!edit_select_address?.address) {
            toast("please enter your Address:")
            set_Is_Loading(false)
            return
        }
        if (!mobileNumber) {
            toast("please enter Phone Number:")
            set_Is_Loading(false)
            return
        }
        if (!edit_select_address?.city) {
            toast("please enter your city:")
            set_Is_Loading(false)
            return
        }
        if (!edit_select_address?.state) {
            toast("please enter your state:")
            set_Is_Loading(false)
            return
        }
        if (!edit_select_address?.country) {
            toast("please enter your country:")
            set_Is_Loading(false)
            return
        }
        if (!edit_select_address?.pin_code) {
            toast("please enter your pin code:")
            set_Is_Loading(false)
            return
        }
        if (!edit_select_address?.landmark) {
            toast("please enter your landmark:")
            set_Is_Loading(false)
            return
        }
        if (!edit_select_address?.address_type) {
            toast("please select address type:")
            set_Is_Loading(false)
            return
        }
        if (!isValid) {
            toast("Please enter a valid phone number containing only numbers.");
            set_Is_Loading(false)
            return;
        }
        try {
            const token = User_Authentication();
            if (!token) {
                set_Is_Loading(false);
                toast.error("User token not found");
                return;
            }
            const response = await Update_Shipping_Address(data, { Authorization: `Bearer ${token}` })
            if (response?.data?.status == "200") {
                set_Is_Loading(false)
                set_Address_list((prevList) =>
                    prevList.map((address) =>
                        address.id === data.id ? { ...address, ...data } : address
                    )
                );
                setIsPopupOpen(false)
            }
        }
        catch (error) {
            set_Is_Loading(false)
        }
    }

    // Close the popup
    const Handle_Close_Popup = () => {
        setIsPopupOpen(false);
        set_Edit_Select_Address(null);
    };

    // <----- Handle the active shiping address ---------->
    const Handle_active_shiping_address = async (id) => {
        const token = User_Authentication();
        set_Is_Loading(true)
        try {
            if (!token) {
                set_Is_Loading(false);
                throw new Error("User token not found");
            }
            const data = {
                address_id: id
            }
            const response = await Default_Shipping_Address(data, { Authorization: `Bearer ${token}` })
            if (response?.data?.status == "200") {
                // set_Active_Shiping_Address(id);
                onActiveShippingAddressChange(id);
                await Handle_Get_Address_List();
                // Notify parent
                set_Is_Loading(false)

            }
            else if (response?.response?.data?.status == "500") {
                toast.error(response?.response?.data?.message);
                set_Is_Loading(false)

            }
            console.log("response_default_address", response);
        } catch (error) {
            console.error("Error setting default shipping address:", error);
        } finally {
            set_Is_Loading(false)
        }
        // set_Active_Shiping_Address(id);
        // onActiveShippingAddressChange(id); // Notify parent
    };

    useEffect(() => {

        if (address_list?.length > 0) {
            const defaultAddressId = address_list?.find(addr => addr?.set_status)?.id;
            // set_Active_Shiping_Address(defaultAddressId);
            onActiveShippingAddressChange(defaultAddressId);
            return;
        }
        onActiveShippingAddressChange(null);
    }, [address_list]);

    return (
        <>
            {
                is_loading ? (
                    <Loader />
                ) : (
                    <div className="h-auto">

                        {/* <-------- ToastContainer ------------> */}
                        <div className="my-1" >
                            {
                                address_list?.map((address_list_result) => {
                                    return (
                                        <div className={`flex grid-3 justify-between p-5 ${address_list_result?.set_status ? 'bg-red-50' : null}`} onClick={() => Handle_active_shiping_address(address_list_result?.id)}>
                                            <div className="">
                                                <h2 className="mb-3 font-semibold">Shipping address</h2>
                                                <ul className="text-[12px] text-gray-800 grid gap-x-4 grid-cols-2">
                                                    <li className="mb-2"><strong>Address Type: </strong>{address_list_result?.address_type}</li>
                                                    <li className="mb-2"><strong>Name: </strong>{address_list_result?.name}</li>
                                                    <li className="mb-2"><strong>Address: </strong>{address_list_result?.address}</li>
                                                    <li className="mb-2"><strong>{address_list_result?.address_type == "Home" ? "Home" : address_list_result?.address_type == "Office" ? "Office" : "Other Address"}: </strong>{address_list_result?.house_name}</li>

                                                    {address_list_result?.phone_number && address_list_result?.country_code && (
                                                        <li className="mb-2"><strong>Phone Number: </strong>{address_list_result?.country_code}{address_list_result?.phone_number}</li>
                                                    )}
                                                    <li className="mb-2"><strong>City: </strong>{address_list_result?.city} <strong>State: </strong>{address_list_result?.state}</li>
                                                    <li className="mb-2"><strong>Country: </strong>{address_list_result?.country}</li>
                                                    <li className="mb-2"><strong>Landmark: </strong>{address_list_result?.landmark} <strong>pin_code: </strong>{address_list_result?.pin_code}</li>
                                                </ul>
                                            </div>
                                            <div className="flex justify-end border-t-0 rounded-b-lg p-3 px-5 pr-0">
                                                <a href="#" onClick={(e) => {
                                                    e.preventDefault();
                                                    Handle_Open_Edit_Popup(address_list_result);
                                                }} className="block text-lg text-green-600 mr-4  hover:text-primary"><i className="fi-rs-edit mr-2"></i></a>
                                                <a href="#" onClick={() => Handle_Remove_Shipping_Address(address_list_result?.id)} className="block text-lg text-red-600 hover:text-primary"><i className="fi-rr-trash mr-2"></i></a>
                                            </div>
                                        </div>

                                    )
                                })
                            }
                        </div>
                        <div className="flex justify-end mt-2">
                            <Link to="/user-add-new-address"
                                className="danger-btn rounded btn hover:bg-gray-500 text-white
                                 p-3 px-5 bg-[#9F2225] text-sm ">Add New Address</Link>
                        </div>
                    </div>

                )
            }

            {/* <------- Edit address --------> */}
            {
                is_loading ? (
                    <Loader />
                ) : (
                    <>
                        {isPopupOpen && (
                            <div className="fixed inset-0 bg-black bg-opacity-50 flex justify-center items-center z-50">
                                <div className="bg-white p-8 rounded-lg w-[600px] relative">
                                    <h2 className="font-semibold mb-4">Update Address</h2>
                                    <form method='post'>
                                        <div className="flex space-x-8">
                                            <div className="w-full">
                                                <div className="input-grid flex space-x-2.5 mb-4">
                                                    <div className="w-1/2 h-full">
                                                        <div className="input-com">
                                                            <label className="input-label mb-2 text-gray-700 text-[13px] font-medium">Name: *</label>
                                                            <div className="input-wrapper border border-gray-400  overflow-hidden relative">
                                                                <input
                                                                    name="name"
                                                                    value={edit_select_address?.name}
                                                                    onChange={handleInputChange}
                                                                    className="input-field w-full placeholder:text-sm text-sm px-6 text-dark-gray  font-normal bg-white focus:ring-0 focus:outline-none h-[40px]"
                                                                    type="text" required
                                                                />

                                                            </div>
                                                            {errors.name && (
                                                                <span className="text-red-500 text-sm">{errors.name}</span>
                                                            )}
                                                        </div>
                                                    </div>
                                                    <div className="w-1/2 h-full">
                                                        <div className="input-com">
                                                            <label className="input-label mb-2 text-gray-700 text-[13px] font-medium">House/Flat/Block Name: *</label>
                                                            <div className="input-wrapper border border-gray-400  overflow-hidden relative">
                                                                <input
                                                                    name="house_name"
                                                                    value={edit_select_address?.house_name}
                                                                    onChange={handleInputChange}
                                                                    className="input-field w-full placeholder:text-sm text-sm px-6 text-dark-gray  font-normal bg-white focus:ring-0 focus:outline-none h-[40px]"
                                                                    type="text" required
                                                                />
                                                            </div>
                                                            {errors.house_name && (
                                                                <span className="text-red-500 text-sm">{errors.house_name}</span>
                                                            )}
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className="input-grid flex space-x-2.5 mb-4">
                                                    <div className="w-1/2 h-full">
                                                        <div className="input-com">
                                                            <label className="input-label mb-2 text-gray-700 text-[13px] font-medium">Address: *</label>
                                                            <div className="input-wrapper border border-gray-400  overflow-hidden relative">
                                                                <input
                                                                    name="address"
                                                                    value={edit_select_address?.address}
                                                                    onChange={handleInputChange}
                                                                    className="input-field w-full placeholder:text-sm text-sm px-6 text-dark-gray  font-normal bg-white focus:ring-0 focus:outline-none h-[40px]"
                                                                    type="text" required
                                                                />
                                                            </div>
                                                            {errors.address && (
                                                                <span className="text-red-500 text-sm">{errors.address}</span>
                                                            )}
                                                        </div>
                                                    </div>
                                                    <div className="w-1/2 h-full">
                                                        <label className="input-label mb-2 text-gray-700 text-[13px] font-medium">Phone Number: *</label>
                                                        <div className="input-wrapper border border-gray-400  overflow-hidden relative">
                                                            <PhoneInput
                                                                international
                                                                defaultCountry="IN"
                                                                value={phoneNumber}
                                                                onChange={handlePhoneChange}
                                                                onKeyDown={handleKeyDown}
                                                                maxLength={15}
                                                                className="w-full px-4 bg-white text-sm text-gray-700 outline-none focus:ring-2 focus:ring-red-400 h-[40px]"
                                                                placeholder="Enter phone number" />
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className="input-grid flex space-x-2.5 mb-4">
                                                    <div className="w-1/2 h-full">
                                                        <div className="input-com">
                                                            <label className="input-label mb-2 text-gray-700 text-[13px] font-medium">City: *</label>
                                                            <div className="input-wrapper border border-gray-400  overflow-hidden relative">
                                                                <input
                                                                    name="city"
                                                                    value={edit_select_address?.city}
                                                                    onChange={handleInputChange}
                                                                    className="input-field w-full placeholder:text-sm text-sm px-6 text-dark-gray  font-normal bg-white focus:ring-0 focus:outline-none h-[40px]"
                                                                    type="text" required
                                                                />
                                                            </div>
                                                            {errors.city && (
                                                                <span className="text-red-500 text-sm">{errors.city}</span>
                                                            )}
                                                        </div>
                                                    </div>
                                                    <div className="w-1/2 h-full">
                                                        <div className="input-com">
                                                            <label className="input-label mb-2 text-gray-700 text-[13px] font-medium">State / Province: *</label>
                                                            <div className="input-wrapper border border-gray-400  overflow-hidden relative">
                                                                <input
                                                                    name="state"
                                                                    value={edit_select_address?.state}
                                                                    onChange={handleInputChange}
                                                                    className="input-field w-full placeholder:text-sm text-sm px-6 text-dark-gray  font-normal bg-white focus:ring-0 focus:outline-none h-[40px]"
                                                                    type="text" required
                                                                />
                                                            </div>
                                                            {errors.state && (
                                                                <span className="text-red-500 text-sm">{errors.state}</span>
                                                            )}
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className="input-grid flex space-x-2.5 mb-4">
                                                    <div className="w-1/2 h-full">
                                                        <div className="input-com">
                                                            <label className="input-label mb-2 text-gray-700 text-[13px] font-medium">Country: *</label>
                                                            <div className="input-wrapper border border-gray-400  overflow-hidden relative">
                                                                <select
                                                                    name="country"
                                                                    value={edit_select_address?.country}
                                                                    onChange={handleInputChange}
                                                                    className="input-field w-full placeholder:text-sm text-sm px-6 text-dark-gray font-normal bg-white focus:ring-0 focus:outline-none h-[40px] appearance-none"
                                                                    required
                                                                >
                                                                    <option value="" disabled>Select Country</option>
                                                                    {countries.map((country, idx) => (
                                                                        <option key={idx} value={country}>{country}</option>
                                                                    ))}
                                                                </select>
                                                            </div>
                                                            {errors.country && (
                                                                <span className="text-red-500 text-sm">{errors.country}</span>
                                                            )}
                                                        </div>
                                                    </div>
                                                    <div className="w-1/2 h-full">
                                                        <div className="input-com">
                                                            <label className="input-label mb-2 text-gray-700 text-[13px] font-medium">PinCode: *</label>
                                                            <div className="input-wrapper border border-gray-400  overflow-hidden relative">
                                                                <input
                                                                    name="pin_code"
                                                                    value={edit_select_address?.pin_code}
                                                                    onChange={handleInputChange}
                                                                    className="input-field w-full placeholder:text-sm text-sm px-6 text-dark-gray  font-normal bg-white focus:ring-0 focus:outline-none h-[40px]"
                                                                    type="number" required
                                                                />
                                                            </div>
                                                            {errors.pin_code && (
                                                                <span className="text-red-500 text-sm">{errors.pin_code}</span>
                                                            )}
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className="input-grid flex space-x-2.5 mb-4">
                                                    <div className="w-1/2 h-full">
                                                        <div className="input-com">
                                                            <label className="input-label mb-2 text-gray-700 text-[13px] font-medium">Landmark:</label>
                                                            <div className="input-wrapper border border-gray-400  overflow-hidden relative">
                                                                <input
                                                                    name="landmark"
                                                                    value={edit_select_address.landmark}
                                                                    onChange={handleInputChange}
                                                                    className="input-field w-full placeholder:text-sm text-sm px-6 text-dark-gray  font-normal bg-white focus:ring-0 focus:outline-none h-[40px]"
                                                                    type="text" required
                                                                />
                                                            </div>
                                                            {errors.landmark && (
                                                                <span className="text-red-500 text-sm">{errors.landmark}</span>
                                                            )}
                                                        </div>

                                                    </div>
                                                    <div className="w-1/2 h-full mb-4">
                                                        <label
                                                            className="input-label text-[13px] font-medium">Address Type:</label>
                                                        <div
                                                            className="input-wrapper overflow-hidden relative flex items-center ">
                                                            <input placeholder="" onChange={handleInputChange} value="Home" name='address_type'
                                                                className="input-field placeholder:text-sm text-sm px-6 text-gray-700 font-medium bg-white focus:ring-0 focus:outline-none h-[40px]"
                                                                type="radio" required checked={edit_select_address?.address_type === "Home"} /><span className='ml-2'>Home</span>
                                                            <input placeholder="" onChange={handleInputChange} value="Office" name='address_type'
                                                                className="input-field ml-4 placeholder:text-sm text-sm px-6 text-gray-700 font-medium bg-white focus:ring-0 focus:outline-none h-[40px]"
                                                                type="radio" required checked={edit_select_address?.address_type === "Office"} /><span className='ml-2'>Office</span>
                                                            <input placeholder="" onChange={handleInputChange} value="Other" name='address_type'
                                                                className="input-field ml-4 placeholder:text-sm text-sm px-6 text-gray-700 font-medium bg-white focus:ring-0 focus:outline-none h-[40px]"
                                                                type="radio" required checked={edit_select_address?.address_type === "Other"} /><span className='ml-2'>Other</span>
                                                        </div>
                                                        {errors.address_type && (
                                                            <span className="text-red-500 text-sm">{errors.address_type}</span>
                                                        )}
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="action-area">
                                            <button type='submit' onClick={(e) => {
                                                e.preventDefault();
                                                Handle_Edit_Shipping_Address();
                                            }} className="w-[164px] inline-block text-center py-3 bg-[#9F2225] m-2 text-white text-sm">Save</button>
                                            <button type="button" onClick={Handle_Close_Popup} className="w-[164px] inline-block text-center m2 py-3 bg-[gray] text-black text-sm">Cancel</button>
                                        </div>
                                    </form>
                                </div>
                            </div>
                        )}
                    </>
                )
            }
        </>
    )
}

export default Address_List